import { paymentStatusEnum } from '@/constant/payment-info';

/** checkbox 輸入值與 paymentStatus 對照表 */
export const paymentStatusLUT = {
  0: paymentStatusEnum.disable,
  1: paymentStatusEnum.enable,
};
